type Listener = (value: string | undefined) => void;

const values = new Map<string, string>();
const listeners = new Map<string, Set<Listener>>();

export const setPreviewLiveValue = (source: string, value: string) => {
  values.set(source, value);
  listeners.get(source)?.forEach((listener) => listener(value));
};

export const subscribeToPreviewLiveValue = (
  source: string,
  listener: Listener,
) => {
  const sourceListeners = listeners.get(source) ?? new Set<Listener>();
  listeners.set(source, sourceListeners);
  sourceListeners.add(listener);
  listener(values.get(source));

  return () => {
    sourceListeners.delete(listener);
    if (sourceListeners.size === 0) {
      listeners.delete(source);
    }
  };
};

export const clearPreviewLiveValues = () => {
  values.forEach((_value, source) => {
    listeners.get(source)?.forEach((listener) => listener(undefined));
  });
  values.clear();
};
